<template>
  <div>
    <v-container fluid>
      <div class="main">

        <v-row>
          <v-col cols="12">

            <v-card class="rounded-lg shadow" :loading="overlay" :disabled="overlay">

              <v-card-title>
                <div>
                  <v-text-field
                      v-model="keyword"
                      append-icon="mdi-magnify"
                      clearable
                      dense
                      filled
                      hide-details
                      placeholder="Rechercher..."
                      rounded
                      single-line

                  />
                </div>
                <v-spacer/>

                <v-btn color="grey" text
                       @click="getInvestigations(true)">
                  <v-icon left>mdi-refresh</v-icon>
                  Mettre à jour
                </v-btn>

                <v-btn color="grey" text @click="[$refs.filterDialogRef.open(),from='',to='']">
                  <v-icon left>mdi-filter-outline</v-icon>
                  Filtre
                </v-btn>

              </v-card-title>

              <v-divider/>

              <v-card-text v-if="isLoading">
                <v-skeleton-loader type="table"/>
              </v-card-text>

              <div v-else>
                <v-card-text class="pa-0">
                  <v-simple-table v-if="investigations.length">
                    <template v-slot:default>
                      <thead>
                      <tr>
                        <th>Campagne</th>
                        <th class="text-no-wrap">Enquête</th>
                        <th class="text-no-wrap">Nom d'utilisateur</th>
                        <th class="text-no-wrap">Tél d'utilisateur</th>
                        <th>Date de réponse</th>
                        <th>Statut</th>
                        <th>Revue par</th>
                        <th>Revue le</th>
                        <th>Actions</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item ,index) in investigations" :key="index">


                        <td class="text-no-wrap font-weight-bold">
                          {{ item.investigation.opus_campaign.name['fr'] }}
                        </td>

                        <td class="text-no-wrap">
                          {{ item.investigation.name['fr'] }}
                        </td>

                        <td class="text-no-wrap">
                          {{ item.user?.name }}
                        </td>

                        <td class="text-no-wrap">
                          {{ item.user?.phone }}
                        </td>

                        <td class="text-no-wrap">
                          {{ item.answered_at }}
                        </td>

                        <td>
                          <v-chip small
                                  :text-color="item.status_text['text_color']"
                                  :class="item.status_text['class']"
                                  class="font-weight-medium">
                            {{ item.status_text['text'] }}
                          </v-chip>
                        </td>

                        <td class="text-no-wrap">
                          {{ item.reviewed_by?.name }}
                        </td>

                        <td class="text-no-wrap">
                          {{ item.reviewed_at }}
                        </td>

                        <td class="text-no-wrap">
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                  icon
                                  color="gifty"
                                  v-bind="attrs"
                                  v-on="on"
                                  @click="$refs.responsesDialog.open(item)"
                              >
                                <v-icon>mdi-pencil-outline</v-icon>
                              </v-btn>
                            </template>
                            <span>Modifier les SKUs</span>
                          </v-tooltip>
                        </td>

                      </tr>
                      </tbody>
                    </template>
                  </v-simple-table>

                  <div v-else>
                    <NoResults @reload="getInvestigations"/>
                  </div>
                </v-card-text>

                <v-divider/>

                <v-card-actions>

                  <div :style="{width: '120px'}">
                    <v-select v-model="perPage"
                              :items="[10,20,30,50,100]"
                              dense
                              hide-details
                              label="Ligne par page"
                              outlined></v-select>
                  </div>

                  <v-spacer/>

                  <v-pagination v-model="pagination.current"
                                :length="pagination.total"
                                circle
                                total-visible="8"
                                @input="getInvestigations"></v-pagination>

                </v-card-actions>

              </div>
            </v-card>
          </v-col>
        </v-row>
      </div>

      <ResponsesDialog ref="responsesDialog"
                       @refresh="getInvestigations(true)"/>

      <FilterDialog ref="filterDialogRef" @filter="handleFilter($event)"></FilterDialog>


    </v-container>
  </div>
</template>

<script>
import {HTTP} from "@/http-common";
import NoResults from "@/components/NoResults";
import ResponsesDialog from "./components/ResponsesDialog";
import FilterDialog from "./components/FilterDialog";

export default {
  components: {NoResults, ResponsesDialog, FilterDialog},
  data() {
    return {
      keyword: '',
      isLoading: false,
      overlay: false,
      investigations: [],
      total: 0,
      perPage: 10,
      pagination: {
        current: 1,
        total: 0
      },
      from: '',
      to: ''
    };
  },

  methods: {
    handleFilter(filter) {
      const dates = filter.dates
      this.from = dates[0]
      this.to = dates[1]
      this.getInvestigations()
    },
    getInvestigations(overlay = false) {

      if (overlay) {
        this.overlay = true
      } else {
        this.isLoading = true
      }

      HTTP.get('/v1/opus/backoffice/skus?page=' + this.pagination.current, {
        params: {
          perPage: this.perPage,
          keyword: this.keyword,
          from: this.from,
          to: this.to,
        }
      }).then(res => {
        this.pagination.current = res.data.current_page;
        this.pagination.total = res.data.last_page;
        this.total = res.data.total;
        this.investigations = res.data.data

        this.isLoading = false
        this.overlay = false
      }).catch(err => {
        this.isLoading = false
        this.overlay = false
        console.log(err)
      })
    },
  },
  created() {
    this.getInvestigations();
  },
  watch: {
    perPage() {
      this.pagination.current = 1
      this.getInvestigations();
    },
    keyword() {
      this.getInvestigations();
    },
  }
};
</script>

<style scoped>
.cursor-zomm-in {
  cursor: zoom-in;
}

.bg-subtle-warning {
  background: rgba(255, 171, 2, 0.15) !important;
}

.bg-subtle-success {
  background: rgba(121, 215, 15, 0.15) !important;
}

.bg-subtle-error {
  background: rgba(255, 36, 66, 0.15) !important;
}

.bg-subtle-info {
  background: rgba(33, 150, 243, 0.15) !important;
}

.checked-card {
  background-color: rgba(51, 51, 51, 0.08);
}
</style>
